import React from 'react';
import PropTypes from 'prop-types';
import Popup from "semantic-ui-react/dist/es/modules/Popup/Popup.js";
import { getTriggerMarkup } from "./getTriggerMarkup";
export var Component = function Component(_ref) {
  var content = _ref.content,
      size = _ref.size;
  return React.createElement(Popup, {
    color: "grey",
    content: content,
    inverted: true,
    position: "top center",
    size: size,
    trigger: getTriggerMarkup(size)
  });
};
Component.displayName = 'Tooltip';
Component.defaultProps = {
  size: 'small'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  content: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'tiny'])
} : {};